var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 19.6L25.2 19.6L25.2 14L30.8 14L30.8 19.6ZM30.8 42L25.2 42L25.2 25.2L30.8 25.2L30.8 42ZM28.028 56C43.484 56 56 43.456 56 28C56 12.544 43.484 -1.09418e-06 28.028 -2.44539e-06C12.544 -3.79904e-06 3.79904e-06 12.544 2.44784e-06 28C1.09663e-06 43.456 12.544 56 28.028 56ZM28 5.6C40.376 5.6 50.4 15.624 50.4 28C50.4 40.376 40.376 50.4 28 50.4C15.624 50.4 5.6 40.376 5.6 28C5.60001 15.624 15.624 5.6 28 5.6Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningGray);
export default __webpack_public_path__ + "static/media/warning_gray.7b7ed540531c24d66ffb67d2ede445eb.svg";
export { ForwardRef as ReactComponent };